/**
 * @generated SignedSource<<ab5e2f1c411b286f274bb376394510cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrganisationRoleType = "ADMIN" | "DEVELOPER" | "WORKSPACE_USER";
export type WorkspaceRoleType = "ADMIN" | "READ_ONLY";
export type OrgUserInvite = {
  email: string;
};
export type UserWorkspaceRoleInput = {
  role: WorkspaceRoleType;
  workspaceId: string;
};
export type OrgUserInviteMutation$variables = {
  orgRole: OrganisationRoleType;
  roles: ReadonlyArray<UserWorkspaceRoleInput>;
  users: ReadonlyArray<OrgUserInvite>;
};
export type OrgUserInviteMutation$data = {
  readonly organisation: {
    readonly inviteUsers: ReadonlyArray<{
      readonly __typename: "OrgUserFailedResult";
      readonly email: string;
      readonly reason: string;
    } | {
      readonly __typename: "OrgUserInviteSuccessResult";
      readonly user: {
        readonly id: string;
      };
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }> | null;
  };
};
export type OrgUserInviteMutation = {
  response: OrgUserInviteMutation$data;
  variables: OrgUserInviteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgRole"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "roles"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "users"
},
v3 = [
  {
    "kind": "Variable",
    "name": "orgRole",
    "variableName": "orgRole"
  },
  {
    "kind": "Variable",
    "name": "users",
    "variableName": "users"
  },
  {
    "kind": "Variable",
    "name": "workspaceRoles",
    "variableName": "roles"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reason",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgUserInviteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OrgMutation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "inviteUsers",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "type": "OrgUserInviteSuccessResult",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "type": "OrgUserFailedResult",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrgUserInviteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OrgMutation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "inviteUsers",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "OrgUserInviteSuccessResult",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "type": "OrgUserFailedResult",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f4ae76933c1b335f8dd80fcf7492fefc",
    "id": null,
    "metadata": {},
    "name": "OrgUserInviteMutation",
    "operationKind": "mutation",
    "text": "mutation OrgUserInviteMutation(\n  $users: [OrgUserInvite!]!\n  $orgRole: OrganisationRoleType!\n  $roles: [UserWorkspaceRoleInput!]!\n) {\n  organisation {\n    inviteUsers(users: $users, orgRole: $orgRole, workspaceRoles: $roles) {\n      __typename\n      ... on OrgUserInviteSuccessResult {\n        __typename\n        user {\n          id\n        }\n      }\n      ... on OrgUserFailedResult {\n        __typename\n        email\n        reason\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd9ae141717f03099d8a3d9d51579151";

export default node;
